import { makeStyles } from '@material-ui/styles';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import hexToRGBA from 'common/utils/hex-to-rgba';
import theme from 'common/theme';
import Typography from 'common/components/typography';
import { Notice } from '~components/svgs';
import event from '~helpers/mixpanel';
import BusinessForm from './form';

const useStyles = makeStyles(() => ({
  businessWrapper: {
    margin: '80px 0',
    padding: '56px 0 100px',
    textAlign: 'center',
  },
  formWrapper: {
    position: 'relative',
    width: 565,
    padding: '40px 40px 16px',
    boxShadow: `0px 12px 32px 2px ${hexToRGBA(theme.colors.blue6, 0.19)}`,
    background: theme.colors.gray1,
    margin: '0 auto',
    borderRadius: 2,
  },
  title: {
    margin: '0 0 48px !important',
  },
  noticeWrapper: {
    position: 'absolute',
    top: '0',
    left: '100%',
    width: 266,
    padding: '24px 16px',
    background: theme.colors.yellow1,
    textAlign: 'left',
    marginLeft: 24,
    borderRadius: 2,
  },
  notice: {
    height: 20,
    width: 20,
    marginRight: 8,
  },
  noticeList: {
    marginBottom: 0,
    paddingLeft: 24,
  },
  noticeTitle: {
    display: 'flex',
    marginBottom: 10,
  },
}));

const Business = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    event('Viewed OP Business Info Page');
  }, []);

  return (
    <div className={classes.businessWrapper}>
      <Typography
        textType="title"
        type="h2"
        fontSize={24}
        lineHeight={32}
        themeColor={hexToRGBA(theme.colors.gray10, 0.85)}
        className={classes.title}
      >
        {t('landlord.onboarding.business.title')}
      </Typography>

      <div className={classes.formWrapper}>
        <BusinessForm />

        <div className={classes.noticeWrapper}>
          <Typography
            fontSize={14}
            lineHeight={22}
            themeColor={hexToRGBA(theme.colors.gray10, 0.65)}
            className={classes.noticeTitle}
          >
            <Notice className={classes.notice} />
            {t('landlord.onboarding.business.important_notice')}
          </Typography>
          <ul className={classes.noticeList}>
            <li>
              <Typography
                fontSize={12}
                lineHeight={22}
                themeColor={hexToRGBA(theme.colors.gray10, 0.65)}
              >
                {t('landlord.onboarding.business.terms_and_condition')}
              </Typography>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Business;
